// UI Theme constants

export const COLORS = {
  // Basic colors
  WHITE: '#ffffff',
  BLACK: '#000000',
  GRAY_LIGHT: '#e0e0e0',
  GRAY_MEDIUM: '#999',
  GRAY_DARK: '#666',
  
  // Cluster default
  CLUSTER_DEFAULT: '#ccc',
  
  // Stroke colors
  STROKE_DEFAULT: '#fff',
  STROKE_VORONOI: '#999',
  STROKE_HIGHLIGHT: '#000',
  
  // Hexbin heatmap
  HEXBIN_STROKE: '#fff',
  
  // Annotation
  ANNOTATION_LINE: '#999'
};

export const SPACING = {
  ANNOTATION_OFFSET_X: 20,
  ANNOTATION_OFFSET_Y: -300,
  ANNOTATION_WIDTH: 400,
  ANNOTATION_HEIGHT: 500,
  ANNOTATION_HEADER_HEIGHT: 50
};

export const BORDER = {
  RADIUS: 12,
  RADIUS_SMALL: 8
};

export const STROKE_WIDTH = {
  NODE: 1.5,
  PIE: 0.5,
  LINK: 1,
  VORONOI: 1,
  VORONOI_HOVER: 3,
  ANNOTATION: 2,
  THUMBNAIL: 3,
  CONNECTOR_LINE: 2,
  HEXBIN: 0.5
};

export const OPACITY = {
  CLUSTER_VISIBLE: 0.3,
  CLUSTER_HIDDEN: 0,
  NODE_ACTIVE: 1,
  NODE_INACTIVE: 0.1,
  VORONOI_STROKE: 0.5,
  CONNECTOR_LINE: 0.6
};

export const ANIMATION = {
  DASH_ARRAY: '4,4'
};
